import React from 'react';
import { DropdownItem } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import AddEmp from '../../AddEmp/index';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowDropdown from 'components/ListRowDropdown';
import ListRowData from 'components/ListRowData';

class EmpRow extends React.Component {
    constructor() {
        super();
        this.state = {
            menuState: false,
            addEmpState: false,
            deleteCheck: false,
        };
    }

    onEmpOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };

    onEmpClose = () => {
        this.setState({ addEmpState: false, deleteCheck: false });
    };
    onDeleteEmp = (org) => {
        this.setState({ addEmpState: false, deleteCheck: false });
        this.props.onDeleteEmp(org);
    };
    onEditEmp = () => {
        this.setState({ menuState: false, addEmpState: true });
    };

    render() {
        const { width, employee, addFavouriteEmp, onEmpSelect, onSaveEmp, showEmpLoader } = this.props;
        const { menuState, addEmpState, deleteCheck } = this.state;
        const { name, email, phone, starred } = employee;
        const options = ['Edit', 'Deleteit'];
        return (
            <div className="contact-item">
                <ListRowCheckbox
                    selected={employee.selected}
                    onClick={() => {
                        onEmpSelect(employee);
                    }}
                />
                <ListRowFavourite
                    width={width}
                    onClick={() => {
                        addFavouriteEmp(employee);
                    }}
                    starred={starred}
                />
                <ListRowImage width={width} data={employee} />
                <ListRowData lineOne={name} lineTwoLeft={email} lineTwoRight={phone} />
                <ListRowDropdown
                    menuState={menuState}
                    toggle={this.onEmpOptionToggle.bind(this)}
                    options={options}
                    dropdownItems={options.map((option) => (
                        <DropdownItem
                            key={option}
                            onClick={() => {
                                if (option === 'Edit') {
                                    this.onEditEmp();
                                } else if (option === 'Deleteit') {
                                    this.setState({ deleteCheck: true });
                                }
                            }}
                        >
                            {option}
                        </DropdownItem>
                    ))}
                />
                <div>
                    {addEmpState && (
                        <AddEmp
                            open={addEmpState}
                            employee={employee}
                            onSaveEmp={onSaveEmp}
                            onEmpClose={this.onEmpClose}
                            onDeleteEmp={this.onDeleteEmp}
                            showEmpLoader={showEmpLoader}
                        />
                    )}
                </div>
                <SweetAlert
                    show={deleteCheck}
                    warning
                    showCancel
                    confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                    cancelBtnText={<IntlMessages id="button.cancel" />}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={
                        <span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}>
                            <IntlMessages id="general.areYouSure" />
                        </span>
                    }
                    onConfirm={() => {
                        this.onDeleteEmp(employee);
                        this.setState({ deleteCheck: false });
                    }}
                    onCancel={() => {
                        this.setState({ deleteCheck: false });
                    }}
                >
                    <IntlMessages id="emp.deleteEmp" />
                </SweetAlert>
            </div>
        );
    }
}

export default EmpRow;



// WEBPACK FOOTER //
// ./components/Agile/Employee/EmpList/EmpRow/index.js